import React, { useEffect, useState } from 'react';
import { Container, Button, Row, Col, Table, Image } from 'react-bootstrap';
import ApiService from 'services/index';
import { useParams } from 'react-router-dom';

export default function LiveStreamingTicker() {

    const [liveMatch, setLiveMatch] = useState({});
    const { matchId } = useParams();
    const [isMatchOver, setIsMatchOver] = useState(false);
    useEffect(() => {
        // Flag to track if an API call is in progress
        let isFetchingData = false;

        const fetchData = async () => {
            try {
                if (matchId && !isFetchingData && !isMatchOver) {

                    // Set the flag to indicate that an API call is in progress
                    isFetchingData = true;

                    let response = await ApiService.getLiveMatchData(matchId.trim());
                    if (response && response.live && response.live.length) {
                        const match = response.live[0];
                        if (match) {
                            const parsedData = JSON.parse(match.live_data);
                            if (parsedData?.meta?.matchOver) {
                                setIsMatchOver(true);
                            } else {
                                setLiveMatch(match);
                            }
                        }
                    }

                    // Reset the flag when the API call is completed
                    isFetchingData = false;
                }
            } catch (error) {
                // Handle error
                console.log(error);
            }
        };

        fetchData();

        const intervalId = setInterval(fetchData, 10000);

        return () => {
            clearInterval(intervalId);
        };
    }, [matchId, isMatchOver]);




    const getLiveMatchWidget = () => {
        if (isMatchOver) {
            return (
                <Row className='d-flex flex-row justify-content-around text-primary'>
                    <Col xs={12} md={6}><div className='fw-bold'>Apologies for the inconvenience. Either the match ID is invalid, or the match has already concluded.</div></Col>
                </Row>
            );
        }
        if (liveMatch && liveMatch.live_data) {
            const parsedData = JSON.parse(liveMatch.live_data);
            let currInn = parsedData.summary.inn;
            let inn1Bat = parsedData.innings.inn1.bat;
            let inn2Bat = parsedData.innings.inn2.bat;
            let inn1Batname = parsedData.innings.inn1.batname;
            let inn2Batname = parsedData.innings.inn2.batname;
            let inn1Score, inn2Score;
            const i1p = (inn1Bat === parsedData.meta.tm1Id) ? 't1' : 't2';
            const i2p = (inn1Bat === parsedData.meta.tm1Id) ? 't2' : 't1';
            inn1Score = `${parsedData.fullMatch.match[i1p + 'Sc']}/${parsedData.fullMatch.match[i1p + 'Wkt']} (${parsedData.fullMatch.match[i1p + 'DispOv']})`;
            if (currInn === 1) {
                inn2Score = "";
            } else {
                inn2Score = parsedData.summary.inn === 1
                    ? ''
                    : `${parsedData.fullMatch.match[i2p + 'Sc']}/${parsedData.fullMatch.match[i2p + 'Wkt']} (${parsedData.fullMatch.match[i2p + 'DispOv']})`;
            }
            return (
                <>
                    <Row id="live-matches" className='justify-content-center h-50'>

                        <Col xs={12} md={6} lg={2}>
                            <Row className='text-center'>
                                <Col xs={12}>
                                    <Image src="/tca-logo.png"
                                        width="70"
                                        height="70"
                                    />
                                </Col>
                                <Col xs={12} className='text-dark fw-bold fs-4'>
                                    Tennisball Cricket Association
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} md={6} lg={3} className='p-0 mx-1 border rounded'>
                            <div>
                                <Table width="100%" size='sm' className='mb-0'>
                                    <tbody>
                                        <tr>
                                            <th>
                                                <span className="live-team fw-bold fs-4">{inn1Batname}</span>
                                            </th>
                                            <th align='right'>
                                                <span className="live-score1 fw-bold fs-4" dangerouslySetInnerHTML={{ __html: inn1Score }} />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>
                                                <span className="live-team fw-bold fs-4">{inn2Batname}</span>
                                            </th>
                                            <th align='right'>
                                                <span className="live-score1 fw-bold fs-4" dangerouslySetInnerHTML={{ __html: inn2Score }} />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colSpan={2}>
                                                <div className='fw-bold'>
                                                    {parsedData.summary.eq ? <Table borderless width="100%" size='sm' className='mb-0 pb-0'>
                                                        <tbody>
                                                            {parsedData.summary.eq ? <tr>
                                                                <td> {parsedData.summary.eq ? parsedData.summary.eq : ''}</td>
                                                            </tr> : ''}
                                                        </tbody>
                                                    </Table>
                                                        : ""}
                                                </div>
                                            </th>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={3} className='p-0 mx-1 border rounded'>
                            <Table width="100%" size='sm' className='mb-0 fs-4'>
                                <thead>
                                    <tr>
                                        <th>Batsmen</th>
                                        <th>Runs (Balls)</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="fs-4">
                                            {parsedData.summary.bat.on.name}

                                        </td>
                                        <td className="fw-bold">{parsedData.summary.bat.on.r}({parsedData.summary.bat.on.b})</td>


                                    </tr>
                                    <tr>
                                        <td className="fs-4">
                                            {parsedData.summary.bat.off.name}
                                        </td>
                                        <td className="fw-bold">{parsedData.summary.bat.off.r} ({parsedData.summary.bat.off.b})</td>
                                    </tr>

                                </tbody>
                            </Table>

                        </Col>

                        <Col xs={12} md={6} lg={3} className='p-0 mx-1 border rounded'>
                            <div>
                                <Table borderless className='m-0 p-0 fs-4' width="100%" size='sm'>
                                    <thead>
                                        <tr>
                                            <th>Bowler</th>
                                            <th>O</th>
                                            <th>M</th>
                                            <th>R</th>
                                            <th>W</th>
                                            <th>Eco.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {parsedData.summary.bowl.name}
                                            </td>
                                            <td>{parsedData.summary.bowl.o}.{parsedData.summary.bowl.b}</td>
                                            <td>{parsedData.summary.bowl.m}</td>
                                            <td>{parsedData.summary.bowl.r}</td>
                                            <td>{parsedData.summary.bowl.w}</td>
                                            <td>{parsedData.summary.bowl.eco}</td>
                                        </tr>
                                    </tbody>
                                </Table>

                            </div>
                        </Col>
                    </Row >
                    <Row className='d-flex flex-row justify-content-around'>
                        <Col xs={6}>


                        </Col>
                    </Row>
                    <Row className='d-flex flex-row justify-content-around'>
                        <Col xs={7}>
                            <Table borderless width="100%" className='p-0 m-0 bg-white text-primary' size='sm'>
                                <tbody>
                                    <tr>
                                        <td className='p-1 m-0 fw-bold fs-3'>Recent Overs :</td> {parsedData.summary.recent.map((oneEntry, index) => {
                                            return <td className='p-1 m-0 fw-bold fs-3' key={index} dangerouslySetInnerHTML={{ __html: oneEntry }}></td>
                                        })}
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </>
            );
        } else {
            return <>Apologies for the inconvenience. Either the match ID is invalid, or the match has already concluded.</>
        }
    }
    return (
        <div className='p-1' style={{ fontSize: 'small', backgroundColor: '#fff', position: 'fixed', bottom: 0, left: 0, right: 0, color: '#fff' }}>
            <div className='border-top pt-1 border-2'>
                {getLiveMatchWidget()}
            </div>
        </div>
    );
}
